import styled from 'styled-components';

export const StyledAutoComplete = styled('div')`
  .MuiAutocomplete-root {
    width: 100% !important;
  }

  .MuiOutlinedInput-root {
    padding-right: 10px !important;
  }
`;
